import { wrapRequest } from '@applandeo/api-wrapper';
import { parseISO } from 'date-fns';
import { useEffect, useState } from 'react';

import { getRequestPreview } from '@/dataExchange/services/newRequest.service';
import { RequestSummary } from '@/domain/newRequest';
import { AbsenceWithTypeData } from '@/domain/requestsPage';
import { useRequestsConverter } from '@/hooks/useRequests/useRequestsConverter';
import { normalizeDateForAPI } from '@/utils/date/date';

const useLimitSummary = (requestDetails: AbsenceWithTypeData) => {
    const getRequestPreviewWrapper = wrapRequest(getRequestPreview);
    const { convertRequestPreviewResponseDtoToRequestSummary } = useRequestsConverter();

    const [summary, setSummary] = useState<RequestSummary>();

    useEffect(() => {
        getRequestPreviewWrapper
            .fetch({
                userId: requestDetails.userId,
                requestBody: {
                    from: normalizeDateForAPI(parseISO(requestDetails.from)),
                    to: normalizeDateForAPI(parseISO(requestDetails.to)),
                    absenceTypeId: requestDetails.absenceTypeId,
                    comment: requestDetails.comment,
                },
            })
            .onSuccess(response => {
                const requestSummary = convertRequestPreviewResponseDtoToRequestSummary(response);

                setSummary(requestSummary);
            });
    }, [requestDetails]);

    return { summary };
};

export default useLimitSummary;
